/**
 * Single source of truth for the frontend API base URL.
 *
 * Mirrors Batch 1's prod-startup-guard philosophy: a missing
 * VITE_API_URL in a production build is a misconfiguration that should
 * fail loudly at module load, not silently route every request to
 * localhost (which fails with connection-refused errors that look
 * like backend outages).
 *
 * Dev (`MODE === 'development'`) and tests (`MODE === 'test'`) keep
 * the localhost:3000 fallback so neither requires the env var to be set.
 *
 * See docs/investigations/auth-callback-frontend-batch3-prep-2026-05-01.md
 * Section 3.2 for the rationale.
 */
// Treat both `undefined` and empty string as "unset" — Vercel deployments
// can render an unset env var as either, and silently routing to localhost
// in production is the bug we're closing off.
const apiBase = import.meta.env.VITE_API_URL as string | undefined;

if (!apiBase && import.meta.env.MODE === 'production') {
  throw new Error(
    '[apiBase] FATAL: VITE_API_URL is not set in production build. ' +
    'Configure it in Vercel project environment variables.',
  );
}

export const API_BASE = apiBase || 'http://localhost:3000';
